import { render, staticRenderFns } from "./CustomPageMake.vue?vue&type=template&id=425e611a&scoped=true&"
import script from "./CustomPageMake.vue?vue&type=script&lang=js&"
export * from "./CustomPageMake.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageMake.vue?vue&type=style&index=0&id=425e611a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e611a",
  null
  
)

export default component.exports